var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9504 11.88V19.605C28.9504 24.225 26.3104 26.205 22.3504 26.205H9.16542C8.49042 26.205 7.84542 26.145 7.24542 26.01C6.87042 25.95 6.51044 25.845 6.18044 25.725C3.93044 24.885 2.56543 22.935 2.56543 19.605V11.88C2.56543 7.25997 5.20542 5.28003 9.16542 5.28003H22.3504C25.7104 5.28003 28.1254 6.70502 28.7704 9.96002C28.8754 10.56 28.9504 11.175 28.9504 11.88Z",
    fill: "#0DB6B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4501 16.38V24.105C33.4501 28.725 30.8101 30.705 26.8501 30.705H13.6651C12.5551 30.705 11.5501 30.555 10.6801 30.225C8.89513 29.565 7.68012 28.2 7.24512 26.01C7.84512 26.145 8.49012 26.205 9.16512 26.205H22.3501C26.3101 26.205 28.9501 24.225 28.9501 19.605V11.88C28.9501 11.175 28.8901 10.545 28.7701 9.96002C31.6201 10.56 33.4501 12.57 33.4501 16.38Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7501 19.71C17.9371 19.71 19.7101 17.937 19.7101 15.75C19.7101 13.563 17.9371 11.79 15.7501 11.79C13.563 11.79 11.79 13.563 11.79 15.75C11.79 17.937 13.563 19.71 15.7501 19.71Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16992 12.375C6.55492 12.375 6.04492 12.885 6.04492 13.5V18C6.04492 18.615 6.55492 19.125 7.16992 19.125C7.78492 19.125 8.29492 18.615 8.29492 18V13.5C8.29492 12.885 7.79992 12.375 7.16992 12.375Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3154 12.375C23.7004 12.375 23.1904 12.885 23.1904 13.5V18C23.1904 18.615 23.7004 19.125 24.3154 19.125C24.9304 19.125 25.4404 18.615 25.4404 18V13.5C25.4404 12.885 24.9454 12.375 24.3154 12.375Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneys);
export default __webpack_public_path__ + "static/media/moneys.08b896bb9eec1f223884e9c771bd2760.svg";
export { ForwardRef as ReactComponent };